// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetOfferFromHistoryWebRequest,
  TGetOfferFromHistoryWebModel,
  IMappers,
  TGetOfferFromHistoryWebResponse_,
  TGetOfferFromHistoryWebResponse,
  TGetOfferFromHistoryWebResponse_1,
  TGetOfferFromHistoryWebResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';

export function createGetOfferFromHistoryWebModel(
  parameters: IGetOfferFromHistoryWebRequest,
): TGetOfferFromHistoryWebModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'valuation-offer-history',
    pathApi: '/v2/get-offer-from-history-web/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetOfferFromHistoryWebOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetOfferFromHistoryWebRequest;
}

export async function fetchGetOfferFromHistoryWeb<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetOfferFromHistoryWebOptions<TResponse200, TResponse400>): Promise<
  TGetOfferFromHistoryWebResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetOfferFromHistoryWebModel(parameters),
    config,
  )) as FetchResponse<TGetOfferFromHistoryWebResponse_>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TGetOfferFromHistoryWebResponse_1, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as TGetOfferFromHistoryWebResponseError, headers);
    }
  }
  return {
    statusCode,
    response,
    headers: Array.from(headers),
  } as TGetOfferFromHistoryWebResponse;
}
